import { ResourceDetail } from '@cibo/core'
import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import { useEffect, useState } from 'react'
import { TraitCellEditorProps } from '../../types'

import { useTranslation } from 'react-i18next'

const answerFromDetail = (detail?: ResourceDetail) => {
  return detail?.result === undefined ? '' : detail?.result?.wetlandCompliance
}

export const WetlandComplianceCellEditor = ({
  traitId,
  year,
  params,
  saveDetail,
  removeDetail,
  disabled,
}: TraitCellEditorProps) => {
  const { t } = useTranslation('@cibo/landmanager/WetlandCompliance')
  const detail = params.row.resolveStandingDetail(traitId, year)
  const [answer, setAnswer] = useState(answerFromDetail(detail))

  useEffect(() => {
    setAnswer(answerFromDetail(detail))
  }, [detail])

  const handleChange = (_: any, value: any) => {
    if (value !== null) {
      setAnswer(value)

      if (value === '') {
        removeDetail({
          resourceId: params.row.resourceId,
          traitId,
          year,
        })
      } else {
        saveDetail({
          resourceId: params.row.resourceId,
          details: [{ traitId, year, input: { wetlandCompliance: value } }],
        })
      }
    }
  }

  return (
    <ToggleButtonGroup
      exclusive
      disabled={disabled}
      value={answer}
      onChange={handleChange}
      sx={{ marginRight: 1 }}
      data-testid={`eqip-irrigation-method_editor`}
    >
      {[true, false].map(answer => (
        <ToggleButton
          key={`${answer}`}
          value={answer}
          aria-label={t(`wetlandCompliance_${answer}`) as string}
        >
          {t(`wetlandCompliance_${answer}`)}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  )
}
